
















































































































import Vue from 'vue'
import AuthorizationAlert from '@/components/CreateCheck/AuthorizationAlert.vue'
// import ExistingQueryModal from '@/components/CreateCheck/ExistingQueryModal.vue'

import firebase from 'firebase/app'
import 'firebase/functions'
import { mapGetters } from 'vuex'

import ColombiaPerson from '@/components/CreateCheck/CheckTypesForms/Person/Colombia/SimpleForm.vue'
import ColombiaPersonExtra from '@/components/CreateCheck/CheckTypesForms/Person/Colombia/ExtraInputsForm.vue'
import MexicoPerson from '@/components/CreateCheck/CheckTypesForms/Person/Mexico/SimpleForm.vue'
import MexicoPersonExtra from '@/components/CreateCheck/CheckTypesForms/Person/Mexico/ExtraInputsForm.vue'
import BrazilPerson from '@/components/CreateCheck/CheckTypesForms/Person/Brazil/SimpleForm.vue'
import BrazilPersonExtra from '@/components/CreateCheck/CheckTypesForms/Person/Brazil/ExtraInputsForm.vue'
import ChilePerson from '@/components/CreateCheck/CheckTypesForms/Person/Chile/SimpleForm.vue'
import ChilePersonExtra from '@/components/CreateCheck/CheckTypesForms/Person/Chile/ExtraInputsForm.vue'
import PeruPerson from '@/components/CreateCheck/CheckTypesForms/Person/Peru/SimpleForm.vue'
import PeruPersonExtra from '@/components/CreateCheck/CheckTypesForms/Person/Peru/ExtraInputsForm.vue'

import NotSupported from '@/components/CreateCheck/CheckTypesForms/NotSupported.vue'

import { CheckType } from '@/store/modules/result/state'

import Modal from '@/components/Modal/Modal.vue'
import FreeChecksOverModal from '@/components/CreateCheck/FreeChecksOverModal.vue'

import { MAX_CHECKS_ALLOWED } from '@/config/constants'

const countryKeys = {
  CO: {
    text: 'Colombia',
    value: 'CO'
  },
  MX: {
    text: 'México',
    value: 'MX'
  },
  PE: {
    text: 'Perú',
    value: 'PE'
  },
  BR: {
    text: 'Brasil',
    value: 'BR'
  },
  CL: {
    text: 'Chile',
    value: 'CL'
  }
} as Record<string, {text: string; value: string; }>

export default Vue.extend({
  name: 'CreateCheckForm',
  components: {
    AuthorizationAlert,
    ColombiaPerson,
    ColombiaPersonExtra,
    MexicoPerson,
    MexicoPersonExtra,
    NotSupported,
    BrazilPerson,
    BrazilPersonExtra,
    ChilePerson,
    ChilePersonExtra,
    PeruPerson,
    PeruPersonExtra,
    Modal,
    FreeChecksOverModal
    // ExistingQueryModal
  },
  data: () => ({
    defaultCheckType: 'person' as CheckType,
    country: 'CO',
    documentType: 'Cédula de identidad',
    identificationNumber: '',
    expeditionDate: '',
    showExpeditionDatePicker: false,
    showMoreInformation: false,
    authorizationGranted: false,
    showAuthorizationAlert: false,

    showExistingQueryModal: false,
    showFreeChecksOverModal: false,
    loading: false,

    showBirthdayPicker: false,
    birthday: '',
    phoneNumber: '',
    createCheckForms: {
      person: {
        CO: ColombiaPerson,
        MX: MexicoPerson,
        BR: BrazilPerson,
        CL: ChilePerson,
        PE: PeruPerson
      },
      vehicle: {},
      company: {}
    } as Record<CheckType, Record<string, any>>,
    extraInputsForms: {
      person: {
        CO: ColombiaPersonExtra,
        MX: MexicoPersonExtra,
        BR: BrazilPersonExtra,
        CL: ChilePersonExtra,
        PE: PeruPersonExtra
      },
      vehicle: { },
      company: { }
    } as Record<CheckType, Record<string, any>>
  }),
  methods: {
    buildUrlEncoded (checkInput: Record<string, any>): string {
      const form = new URLSearchParams({
        ...checkInput,
        user_authorized: this.authorizationGranted.toString(),
        country: this.country,
        type: this.getCheckType,
        force_creation: 'false'
      })

      return form.toString()
    },
    async createCheck () { // call saga when doing for production
      if (!this.authorizationGranted) {
        this.showAuthorizationAlert = true
        return
      }

      this.loading = true

      try {
        const countryForm = this.$refs.countryForm as any
        const extraInputsForm = this.$refs.extraInputsForm as any

        const formInputs = countryForm.buildCheckInput()
        const extraInputs = extraInputsForm && extraInputsForm.buildCheckInput() // TODO: ignore when extra inputs are collapsed

        const checkInput = {
          ...formInputs,
          ...extraInputs
        }

        // @ts-ignore
        const urlEncoded = this.buildUrlEncoded(checkInput)

        const response = await firebase.functions().httpsCallable('createCheck')({
          urlEncoded
        })

        const { check_id: checkID } = response.data.check

        this.$router.push({ name: 'CheckResult', params: { id: checkID } })
      } catch (error) {
        console.error('Error creating check:', error)
      } finally {
        this.loading = false
      }
    },
    closeDialog (): void {
      this.showExistingQueryModal = false
      this.loading = false
    },
    closeAuthorizationAlert (): void {
      this.showAuthorizationAlert = false
    },
    getCountryName (code: string): string {
      return countryKeys[code].text
    },
    onShowMoreInformation () {
      this.showMoreInformation = !this.showMoreInformation

      if (this.showMoreInformation) {
        this.$gtag.event('more_info_displayed', {
          check_country: this.country,
          check_type: this.getCheckType
        })
      }
    }
  },
  computed: {
    countryItems () {
      return Object.entries(countryKeys).map(countryKey => {
        return {
          text: this.$t(`${countryKey[1].text}`),
          value: countryKey[1].value
        }
      })
    },
    formLink () {
      const locale = this.$i18n.locale

      if (locale === '') {
        return 'https://account.truora.com/account#/es/quiz'
      }

      return `https://account.truora.com/account#/${locale}/quiz`
    },
    ...mapGetters('results', ['getChecksCounter', 'getCheckType', 'getChecksCounterUpdated']),
    ...mapGetters('language', ['getLanguage'])
  },
  watch: {
    getCheckType () {
      this.showMoreInformation = false
    },
    country () {
      this.showMoreInformation = false
    },
    getChecksCounter (value) {
      this.showFreeChecksOverModal = (value <= MAX_CHECKS_ALLOWED - 1)
    },
    getChecksCounterUpdated () {
      this.showFreeChecksOverModal = (this.getChecksCounter <= MAX_CHECKS_ALLOWED - 1)
    }
  },
  mounted () {
    // This is important because as the counter starts at 0, there is no
    // way to know if 0 is the default value or the amount of free checks left
    if (this.getChecksCounterUpdated && this.getChecksCounter <= MAX_CHECKS_ALLOWED - 1) {
      this.showFreeChecksOverModal = true
    }
  }
})
